import type { InputBaseComponentProps } from '@material-ui/core/InputBase'
import React from 'react'
import type { MaskedInputProps } from 'react-text-mask'
import MaskedInput from 'react-text-mask'
import { useClientOptions } from '../../providers/ClientOptionsProvider'

export type PhoneNumberInputProps = InputBaseComponentProps & MaskedInputProps & { separator?: '-' | '.' }

// use as `inputComponent` prop in InputField component
// ex: <InputField inputComponent={PhoneNumberInput} />
const PhoneNumberInput = (props: PhoneNumberInputProps) => {
  const { ...other } = props
  const separator = props.separator ?? '.'

  const { options } = useClientOptions()
  const internationalMode = options?.options?.internationalMode ?? false

  return (
    <MaskedInput
      {...other}
      ref={() => {
        // inputRef(ref ? ref.inputElement : null)
      }}
      showMask={false}
      mask={
        internationalMode
          ? (input) => Array.from(input).map(() => /\d/)
          : [/[1-9]/, /\d/, /\d/, separator, /\d/, /\d/, /\d/, separator, /\d/, /\d/, /\d/, /\d/]
      }
      placeholderChar={'\u2000'}
    />
  )
}

export const PhoneNumberExtensionInput = (props: PhoneNumberInputProps) => {
  const { ...other } = props

  const { options } = useClientOptions()
  const internationalMode = options?.options?.internationalMode ?? false

  return (
    <MaskedInput
      {...other}
      showMask={false}
      mask={internationalMode ? (input) => Array.from(input).map(() => /\d/) : [/[1-9]/, /\d/, /\d/, /\d/, /\d/]}
      placeholderChar={'\u2000'}
    />
  )
}

export default PhoneNumberInput
